export const collectionTemplate = () => {

    const $tribeCollection = document.querySelector(".collection-template");
    if ($tribeCollection) {
        const $contentsLoadMore = $tribeCollection.querySelector(".contents__load-more");
        const $contentsFilters = $tribeCollection.querySelector(".contents__filters");
        const $filtersButton = $contentsFilters?.querySelector(".filters__button");
        const $filtersFlyout = $contentsFilters?.querySelector(".filters__flyout");

        //Filters - filters don't have to be enabled
        if ($filtersButton && $filtersFlyout) {

            //bind filter open button
            $filtersButton.addEventListener("click", (event) => {
                event.preventDefault();
                if ($filtersFlyout.classList.contains("filters__flyout--active")) {
                    $filtersFlyout.classList.remove("filters__flyout--active");
                } else {
                    $filtersFlyout.classList.add("filters__flyout--active");
                }
            });

            //Bind close event on the X button
            const $topClose = $filtersFlyout.querySelector(".top__close");
            $topClose?.addEventListener("click", (event) => {
                event.preventDefault();
                $filtersFlyout.classList.remove("filters__flyout--active");
            });

            //clicking on background to close
            $filtersFlyout.addEventListener("click", (event) => {
                if (event.target == $filtersFlyout) {
                    $filtersFlyout.classList.remove("filters__flyout--active");
                }
            });

            const $flyoutPannel = $filtersFlyout.querySelector(".flyout__pannel");
            const $pannelContents = $flyoutPannel.querySelector(".pannel__contents");

            //Panel Sort By
            const $pannelSortBy = $pannelContents?.querySelector(".pannel__sort-by");
            const $selectInput = $pannelSortBy?.querySelector(".sort-by__select .select__input");

            //Other panel lists - Price, Country, Availability, Process
            const $pannelList = $pannelContents?.querySelector(".pannel__list");
            const $pannelListItems = $pannelList?.querySelectorAll(".list__item");

            if ($pannelListItems) {
                $pannelListItems.forEach(($pannelListItem) => {

                    const $itemButton = $pannelListItem.querySelector(".item__button");
                    const $itemOptions = $pannelListItem.querySelector(".item__options");

                    if ($itemButton && $itemOptions) {

                        //bind click - toggles opening the filter options
                        $itemButton.addEventListener("click", (event) => {
                            event.preventDefault();
                            if ($itemOptions.classList.contains("item__options--active")) {
                                $itemOptions.classList.remove("item__options--active","flex");
                                $itemOptions.classList.add("hidden");
                                $itemButton.querySelector('svg').classList.remove("arrow-active");
                            } else {
                                $itemOptions.classList.add("item__options--active","flex");
                                $itemOptions.classList.remove("hidden");
                                $itemButton.querySelector('svg').classList.add("arrow-active");
                            }
                        });

                        //Handle checkboxes
                        const $optionItems = $itemOptions.querySelectorAll(".option__item");
                        if ($optionItems) {
                            $optionItems.forEach(($optionItem) => {

                                const $itemButton = $optionItem.querySelector(".item__button");
                                const $itemCheckbox = $optionItem.querySelector(".item__checkbox");
                                const $buttonIconChecked = $itemButton.querySelector(".item__icon .icon__checked");
                                const $buttonIconUnchecked = $itemButton.querySelector(".item__icon .icon__unchecked");

                                if ($itemButton && $itemCheckbox && $buttonIconChecked && $buttonIconUnchecked) {
                                    $itemButton.addEventListener("click", (event) => {

                                        event.preventDefault();
                                        if ($itemCheckbox.checked) {

                                            $itemCheckbox.checked = false;
                                            $optionItem.classList.remove("option__item--active");
                                            $buttonIconUnchecked.classList.remove("hidden");
                                            $buttonIconChecked.classList.add("hidden");

                                        } else {
                                            
                                            $buttonIconUnchecked.classList.add("hidden");
                                            $buttonIconChecked.classList.remove("hidden");
                                            
                                            $itemCheckbox.checked = true;
                                            $optionItem.classList.add("option__item--active");
                                        }
                                    });
                                }
                            });
                        }
                    }
                });

                // Pannel Bottom
                const $pannelBottom = $flyoutPannel.querySelector(".pannel__bottom");
                const $bottomApply = $pannelBottom?.querySelector(".bottom__apply");

                if ($bottomApply) {
                    
                    $bottomApply.addEventListener("click", (event) => {
                        event.preventDefault();
                        const filtersMap = new Map();
                        let filterURL = new URL(window.location.href);

                        if ($selectInput.value == "featured") {
                            filterURL.searchParams.delete("sort_by");
                        } else {
                            filterURL.searchParams.set("sort_by", $selectInput.value);
                        }

                        $pannelListItems.forEach(($pannelListItem) => {
                            filterURL.searchParams.delete(
                                $pannelListItem.dataset.paramName
                            );
            
                            if ($pannelListItem.dataset.paramType == "price_range") {
                                if ($pannelListItem.dataset.paramMinName) {
                                    filterURL.searchParams.delete(
                                        $pannelListItem.dataset.paramMinName
                                    );
                                }
                                if ($pannelListItem.dataset.paramMaxName) {
                                    filterURL.searchParams.delete(
                                        $pannelListItem.dataset.paramMaxName
                                    );
                                }
            
                                const $fromValue = $pannelListItem.querySelector(
                                    ".item__options .option__from .from__value"
                                );
                                const $toValue = $pannelListItem.querySelector(
                                    ".item__options .option__to .to__value"
                                );
                                
                                if (parseFloat($fromValue.value)) {
                                    filtersMap.set(
                                        $pannelListItem.dataset.paramMinName,
                                        [parseFloat($fromValue.value)]
                                    );
                                }
                                if (parseFloat($toValue.value)) {
                                    filtersMap.set(
                                        $pannelListItem.dataset.paramMaxName,
                                        [parseFloat($toValue.value)]
                                    );
                                }
                            } else {
                                const $checkboxes = $pannelListItem.querySelectorAll(
                                    ".option__item .item__checkbox"
                                );
            
                                const values = [];
                                $checkboxes.forEach(($checkbox) => {
                                    if ($checkbox.checked) {
                                        values.push($checkbox.value);
                                    }
                                });
                                if (values.length > 0) {
                                    filtersMap.set(
                                        $pannelListItem.dataset.paramName,
                                        values
                                    );
                                }
                            }
                        });

                        filtersMap.forEach((value, key) => {
                            value.forEach((item) => {
                                filterURL.searchParams.append(key, item);
                            });
                        });
                        window.location.href = filterURL.href;
                    });

                    const $bottomClear = $pannelBottom.querySelector(".bottom__clear");
                    if ($bottomClear) {
                        $bottomClear.addEventListener("click", (event) => {
                            event.preventDefault();
                            let filterURL = new URL(window.location.href);
    
                            filterURL.searchParams.delete("sort_by");
    
                            $pannelListItems.forEach(($pannelListItem) => {
                                filterURL.searchParams.delete(
                                    $pannelListItem.dataset.paramName
                                );
    
                                if ($pannelListItem.dataset.paramType == "price_range") {
                                    if ($pannelListItem.dataset.paramMinName) {
                                        filterURL.searchParams.delete(
                                            $pannelListItem.dataset.paramMinName
                                        );
                                    }
                                    if ($pannelListItem.dataset.paramMaxName) {
                                        filterURL.searchParams.delete(
                                            $pannelListItem.dataset.paramMaxName
                                        );
                                    }
                                } else {
                                    filterURL.searchParams.delete(
                                        $pannelListItem.dataset.paramName
                                    );
                                }
                            });
    
                            filterURL.searchParams.delete("page");
    
                            window.location.href = filterURL.href;
                        });
                    }
                
                }
            }
        }        

        if ($contentsLoadMore) {
            $contentsLoadMore.addEventListener("click", async (event) => {

                event.preventDefault();
                const $grid = $tribeCollection.querySelector(".products__grid");

                if ($grid) {

                    const nextPage = parseInt($grid.dataset.collectionPage) + 1;
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.set("page", nextPage);

                    const response = await fetch(currentUrl);
                    const text = await response.text();
                    const $newPage = document.createElement("div");
                    $newPage.innerHTML = text;

                    const $items = $newPage.querySelectorAll(
                        ".products__grid .grid__item"
                    );

                    $items.forEach(($item) => {
                        $grid.append($item);
                    });

                    //Bring across the quick add popups for the cards we just appended,
                    //otherwise their Quick Add buttons have nothing to open.
                    const $newPopups = $newPage.querySelectorAll(
                        ".quick-add-popup-container .quick-add-popup"
                    );
                    const $popupContents = $tribeCollection.querySelector(
                        ".quick-add-popup-container .quick-add-popup-contents"
                    );
                    if ($popupContents) {
                        $newPopups.forEach(($newPopup) => {
                            const exists = $popupContents.querySelector(
                                `.quick-add-popup[data-popup-id="${$newPopup.dataset.popupId}"]`
                            );
                            if (!exists) {
                                $popupContents.append($newPopup);
                            }
                        });
                    }

                    $grid.dataset.collectionPage = parseInt($grid.dataset.collectionPage) + 1;

                    if ($grid.dataset.collectionPage == $grid.dataset.collectionNumberOfPages) {
                        $contentsLoadMore.classList.add("hidden");
                    }

                    const images = document.querySelectorAll("img[data-preload]");
                    for (const image of images) {
                        if (image.getAttribute("data-preload") !== "loaded") {
                            const src = image.getAttribute("data-preload")
                                ? image.getAttribute("data-preload")
                                : image.getAttribute("src");
                            if (src) {
                                image.setAttribute("src", src);
                                image.removeAttribute("data-preload");
                            }
                        }
                    }
                }
            });
        }   
    }
};

export default collectionTemplate;
